<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    
    <CSidebarBrand class="d-md-down-none" to="/">

      <span class="c-sidebar-brand-full display-5">
        <form>
          <!-- <select class="form-control form-select" @change="onModuleChange($event)" size="sm" 
              title="Choose Module" v-model="module">
            <option v-for="mod in this.$store.state.mods">
              {{ mod }}
            </option>
          </select> -->

          <select class="form-control form-select" v-model="module">
            <option selected>Attendance Ledger</option>
            <option>Payroll Ledger</option>
            <option>Admin</option>
        </select>
        </form>
      </span>

      <!-- <span class="c-sidebar-brand-full display-5">
        Pay.SignLedger
      </span>
      <span class="c-sidebar-brand-minimized display-5">
        Pay
      </span> -->

    </CSidebarBrand>


    {{userMessage}}


    <!-- <CRenderFunction flat :content-to-render="$options.nav"/> -->
    <!-- <CRenderFunction :contentToRender="computedSidebar" flat/> -->
    <CRenderFunction :contentToRender="sideBarMenu" flat/>

    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>

const homeItem = {
        _name: 'CSidebarNavItem',
        name: 'Home',
        icon: 'cil-home',
        to: '/',
      }

const contactItem = {
        _name: 'CSidebarNavItem',
        name: 'Contact SignLedger',
        to: '/admin/contact',
        icon: 'cil-envelope-open',
      }

const manualItem =  {
        _name: 'CSidebarNavItem',
        name: 'Admin User Manual',
        to: '/admin/usermanual',
        icon: 'cil-info',
      }


export default {
  name: 'TheSidebar',

  components: {
  },

  data() {
    return {
      userMessage: "",
      sideBarMenu: [],
      module: 'Attendance Ledger',
      //sideBarMenu: [{_name: "CSidebarNav",_children: noItems}],
    }
  },

  watch: {
    module: function (val) {
      this.refreshSidebar()
    }
  },

  //nav1,
  computed: {
    show () {
      return this.$store.state.sidebarShow 
    },

    minimize () {
      return this.$store.state.sidebarMinimize 
    },
  },

  mounted() {
    var self = this
    self.refreshSidebar()

    // 'refreshSidebar' : Triggered by - Signin, Signout (from Header)
    this.bus.$on('refreshSidebar', () => {
      self.refreshSidebar()
    })

  },

  methods: {
    refreshSidebar(){
      this.sideBarMenu = this.getMenu(this.$store.state.enableTL,
                                      this.$store.state.enablePL,
                                      this.$store.state.enableSU)
    },

    getMenu(isTimeAdmin, isPayAdmin, isSU){
      var menuChildren = []

      menuChildren.push(homeItem)

      if (isTimeAdmin==true && this.module=='Attendance Ledger'){
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Report - Details', icon: 'cil-bell',to: '/attendance/details',})
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Report - Summary', icon: 'cil-bell',to: '/attendance/summary',})
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Report - Daily', icon: 'cil-bell',to: '/attendance/daily',})
        //menuChildren.push(tlItem)
      }

      if (isPayAdmin==true  && this.module=='Payroll Ledger'){
        menuChildren.push({_name: 'CSidebarNavItem',name: 'User - Pay Data', icon: 'cil-cursor',to: '/pay/userPayData',})
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Latest Pay Reports', icon: 'cil-cursor',to: '/pay/salaryHeader',})
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Past Pay Reports', icon: 'cil-cursor',to: '/pay/salaryHeaderPast',})
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Gratuity', icon: 'cil-cursor',to: '/pay/gratuity',})
        //menuChildren.push(plItem)
      }

      if (isSU==true && this.module=='Admin'){
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Users', icon: 'cil-cursor',to: '/admin/users',})
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Holidays', icon: 'cil-cursor',to: '/admin/holidays',})
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Departments', icon: 'cil-cursor',to: 'Departments',})
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Locations', icon: 'cil-cursor',to: '/admin/locations',})
        menuChildren.push({_name: 'CSidebarNavItem',name: 'Devices', icon: 'cil-cursor',to: '/admin/devices',})
      }

      var menuNav = {}
      menuNav["_name"] = 'CSidebarNav'
      menuNav["_children"] = menuChildren

      return [menuNav]
    },

  },

}
</script>
